import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Reveal from "../../Reveal";
import { useI18n } from "../../../i18n/LanguageContext";
import { SITE } from "../../../content/site";

export default function BrandActivation() {
  const { lang } = useI18n();
  const c = (SITE[lang].homeStory || SITE.en.homeStory).activation;
  const alt = (SITE[lang].events || SITE.en.events).alt;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section ref={ref} data-testid="home-activation" className="bg-white px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 lg:grid-cols-12 lg:gap-10">
        <div className="order-2 lg:order-1 lg:col-span-6">
          <div className="overflow-hidden rounded-3xl">
            <motion.img src="/events/antwerp.jpg" alt={alt.antwerp} loading="lazy" width="1920" height="830"
              style={{ y }} className="h-[52vh] w-full scale-110 object-cover md:h-[72vh]" />
          </div>
        </div>
        <div className="order-1 lg:order-2 lg:col-span-5 lg:col-start-8">
          <Reveal><p className="overline text-[#0e7c6b]">{c.overline}</p></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display mt-7 text-3xl font-light leading-[1.05] tracking-tightest text-[#050505] md:text-5xl">{c.title}</h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-lg text-base font-light leading-relaxed text-[#4a4a4a] md:text-lg">{c.text}</p>
          </Reveal>
          <div className="mt-12 space-y-8">
            {c.points.map((p, i) => (
              <Reveal key={p.k} delay={0.15 + i * 0.1}>
                <div data-testid={`activation-point-${i}`} className="border-t border-black/10 pt-6">
                  <h3 className="font-display text-xl font-normal tracking-tight text-[#050505] md:text-2xl">{p.k}</h3>
                  <p className="mt-3 max-w-lg text-base font-light leading-relaxed text-[#6b6f6c]">{p.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
